<template>
  <div class="main-table-wrapper">
    <el-table :data="data" width="100%">
      <el-table-column :label="$tc('seminar.seminar_name')" min-width="250px">
        <template slot-scope="scope">
          <router-link :to="{ name: 'SeminarView', params: { id: scope.row.id } }" class="link">
            {{ scope.row.name }}
          </router-link>
        </template>
      </el-table-column>

      <el-table-column :label="$tc('tournament.registration_start_date')" width="200px">
        <template slot-scope="scope">
          {{ scope.row.startDate | date('LLL') }}
        </template>
      </el-table-column>

      <el-table-column :label="$tc('tournament.registration_end_date')" width="200px">
        <template slot-scope="scope">
          <span v-if="scope.row.endDate">{{ scope.row.endDate | date('LLL') }}</span>
        </template>
      </el-table-column>

      <el-table-column v-if="canEdit" :label="$tc('general.actions')" width="80px" align="right">
        <template slot-scope="scope">
          <el-dropdown trigger="click" @command="(command) => handleCommand(command, scope.row)">
            <el-button type="primary" icon="el-icon-more" circle />
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="edit"><i class="el-icon-edit" />{{ $tc('general.edit') }}</el-dropdown-item>
              <el-dropdown-item v-if="!scope.row.isArchived" command="archive"><i class="el-icon-takeaway-box" />{{ $tc('general.archive', 2) }}</el-dropdown-item>
              <el-dropdown-item command="delete"><i class="el-icon-delete" />{{ $tc('general.delete') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import errorHandler from '@/common/errorHandler.js'

export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    canEdit: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    handleCommand (command, seminar) {
      if (command === 'edit') {
        this.$router.push({ name: 'EditSeminar', params: { id: seminar.id } })
      } else if (command === 'archive') {
        this.askArchive(seminar)
      } else if (command === 'delete') {
        this.beforeDelete(seminar)
      }
    },

    async askArchive (seminar) {
      try {
        const key = seminar.isCamp ? 'messages.ask_archive_camp' : 'messages.ask_archive_seminar'
        await this.$confirm(this.$tc(key))
        this.doArchive(seminar)
      } catch {}
    },

    async beforeDelete (seminar) {
      try {
        const key = seminar.isCamp ? 'messages.ask_delete_camp' : 'messages.ask_delete_seminar'
        await this.$confirm(this.$tc(key))
        this.onDelete(seminar)
      } catch {}
    },

    async doArchive (seminar) {
      const loading = this.$loading()
      try {
        await this.$store.dispatch('seminars/update', {
          id: seminar.id,
          payload: { isArchived: true }
        })
        const key = seminar.isCamp ? 'messages.success_archived_camp' : 'messages.success_archived_seminar'
        this.$message.success(this.$tc(key))
        this.$emit('refresh')
      } catch (e) {
        console.error(e)
        errorHandler(e)
      } finally {
        loading.close()
      }
    },

    async onDelete (seminar) {
      const loading = this.$loading()
      try {
        await this.$store.dispatch('seminars/delete', seminar.id)
        const key = seminar.isCamp ? 'messages.success_deleted_camp' : 'messages.success_deleted_seminar'
        this.$message.success(this.$tc(key))
        this.$emit('refresh')
      } catch (e) {
        console.error(e)
        errorHandler(e)
      } finally {
        loading.close()
      }
    }
  }
}
</script>
